export const GETTER_USER_UPLOADS_DOCUMENTS_TYPES = "GETTER_USER_UPLOADS_DOCUMENTS_TYPES";
export const ACTION_GET_USER_UPLOADS_DOCUMENTS_TYPES = "ACTION_GET_USER_UPLOADS_DOCUMENTS_TYPES";
export const MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES = "MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES";
export const ACTION_SAVE_USER_UPLOADS_DOCUMENT = "ACTION_SAVE_USER_UPLOADS_DOCUMENT";
export const ACTION_DELETE_USER_UPLOADS_DOCUMENT = "ACTION_DELETE_USER_UPLOADS_DOCUMENT";

export default {
    namespaced: true,
    GETTER_USER_UPLOADS_DOCUMENTS_TYPES,
    ACTION_GET_USER_UPLOADS_DOCUMENTS_TYPES,
    MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES,
    ACTION_SAVE_USER_UPLOADS_DOCUMENT,
    ACTION_DELETE_USER_UPLOADS_DOCUMENT
};